const mediaItems = [
  {
    title: '布丁漫画连续阅读功能演示',
    desc: '一镜到底展示布丁漫画下拉式阅读如何丝滑衔接每一话，从第1话滚动到最新话的完整体验。',
    img: 'https://readdy.ai/api/search-image?query=A%20colorful%20digital%20illustration%20showing%20a%20tablet%20screen%20displaying%20Korean%20manhwa%20webtoon%20in%20continuous%20scroll%20reading%20mode%2C%20warm%20orange%20and%20coral%20color%20scheme%2C%20flat%20vector%20art%20style%2C%20modern%20interface%20with%20comic%20panels%20flowing%20vertically%2C%20soft%20background%20with%20pastel%20warm%20tones&width=800&height=500&seq=media-demo-01&orientation=landscape',
    duration: '03:25',
  },
  {
    title: '韩漫热门作品推荐特辑',
    desc: '盘点布丁漫画网当前最受欢迎的韩漫全集，霸道总裁、甜宠恋爱、悬疑反转一网打尽。',
    img: 'https://readdy.ai/api/search-image?query=A%20vibrant%20illustration%20of%20various%20romance%20and%20drama%20Korean%20manhwa%20covers%20arranged%20in%20a%20collage%20style%2C%20warm%20coral%20and%20peach%20color%20palette%2C%20flat%20digital%20art%2C%20playful%20layout%20with%20speech%20bubbles%20and%20heart%20motifs%2C%20clean%20vector%20illustration&width=800&height=500&seq=media-recommend-02&orientation=landscape',
    duration: '05:18',
  },
  {
    title: '国漫崛起：2026年必追连载',
    desc: '布丁漫画网精选国漫频道热门连载作品，修仙、都市、末日题材全收录，下拉式免费畅读。',
    img: 'https://readdy.ai/api/search-image?query=A%20dynamic%20illustration%20of%20Chinese%20manhua%20comic%20scenes%20featuring%20cultivation%20and%20urban%20fantasy%20themes%2C%20warm%20orange%20and%20amber%20color%20scheme%2C%20flat%20vector%20art%20style%20with%20dramatic%20action%20poses%2C%20clean%20modern%20composition%2C%20soft%20pastel%20background&width=800&height=500&seq=media-chinese-03&orientation=landscape',
    duration: '04:42',
  },
];

export default function Media() {
  return (
    <section id="media" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-4">
            视频推荐
          </span>
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950">
            精彩视频
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-[600px] mx-auto">
            布丁漫画网精选视频内容，快速了解热门作品和阅读技巧
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {mediaItems.map((item) => (
            <div
              key={item.title}
              className="group bg-background-50 border border-background-200/70 rounded-2xl overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-default"
            >
              <div className="relative w-full aspect-video bg-background-200 overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/20 flex items-center justify-center">
                  <div className="w-14 h-14 rounded-full bg-background-50/90 flex items-center justify-center group-hover:bg-primary-500 transition-colors duration-300">
                    <i className="ri-play-fill text-xl text-foreground-800 group-hover:text-background-50 transition-colors duration-300 ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-3 right-3 px-2.5 py-1 rounded-md bg-black/60 text-background-50 text-xs font-medium">
                  {item.duration}
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-base font-semibold text-foreground-900 mb-2 line-clamp-1">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}